import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './config/sentry';

// Initialize Sentry before rendering the app
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ✅ Service Worker RE-AKTIVIERT (1. Nov 2025) mit Network-First + Cache-Busting
// Nur für Production (nicht localhost), registriert sich nach Page Load
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && window.location.hostname !== 'localhost') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// ✅ Service Worker jetzt mit Network-First + Cache-Busting aktiviert (1. Nov 2025)
// Falls alte SW-Version cached ist, wird sie automatisch durch neuen CACHE_NAME ersetzt
